{
  "home": {
    "heroStop": "FERMARE IL HUMAN SAFARI",
    "heroSave": "SALVARE CHERSON",
    "heroTitle1": "Gli esseri umani",
    "heroTitle2": "Non sono bersagli",
    "heroDate": "13-14 dicembre",
    "worldwideRally": "Raduno mondiale",
    "heroHashtags": "#HumansAreNotTargets #StopHumanSafari #SaveKherson",
    "infoText": "Dall'estate 2024, i militari russi utilizzano piccoli droni per cacciare, uccidere e terrorizzare i civili per le strade di Cherson e di altre città al fronte in Ucraina. <bold>Il safari umano deve fermarsi. TU puoi aiutare.</bold> Unisciti a migliaia di persone nel mondo per chiedere che questo crimine di guerra finisca.",
    "seeGallery": "Vedi i poster in tutto il mondo",
    "comingSoon": "Località in arrivo",
    "december": "dicembre",
    "dec": "dic.",
    "october": "ottobre",
    "oct": "ott.",
    "september": "settembre",
    "sep": "sett.",
    "schedule9": "9",
    "schedule10": "10",
    "schedule11": "11",
    "schedule12": "12",
    "schedule13": "13",
    "schedule14": "14",
    "schedule16": "16",
    "schedule18": "18",
    "schedule20": "20",
    "schedule1": "1",
    "schedule2": "2",
    "schedule3": "3",
    "schedule4": "4",
    "schedule5": "5",
    "schedule25": "25",
    "schedule26": "26",
    "schedule27": "27",
    "schedule28": "28",
    "schedule29": "29",
    "schedule30": "30",
    "schedule31": "31",
    "scheduleTBC": "Data da confermare...",
    "recommendationsTitle": "Raccomandazioni della Commissione ONU",
    "recommendationsRussia": "La Commissione raccomanda alla Federazione Russa:",
    "rusRec1": "(a) Porre immediatamente fine agli attacchi dei droni contro civili e obiettivi civili",
    "rusRec2": "(b) Fermare immediatamente tutti gli atti che diffondono il terrore tra la popolazione civile",
    "rusRec3": "(c) Garantire che tutti i responsabili coinvolti negli attacchi dei droni contro civili siano ritenuti responsabili",
    "recommendationsUNStates": "La Commissione raccomanda ad altri Stati e organizzazioni regionali e internazionali:",
    "statesRec1": "(a) Contribuire sia finanziariamente che con consulenza tecnica al governo ucraino e alle organizzazioni della società civile, per fornire supporto completo alle vittime e alle loro famiglie;",
    "statesRec2": "(b) Per i terzi Stati il cui territorio è destinazione di persone deportate dai territori occupati, intraprendere gli sforzi necessari insieme ai servizi consolari ucraini per supportare queste persone.",
    "reference": "Riferimento",
    "linkUN": "Commissione ONU: il 'safari umano' della Russia in Ucraina è un crimine contro l'umanità",
    "linkGuidelines": "Linee guida ONU",
    "linkWiki": "Wikipedia"
  },
  "witnesses": {
    "title": "Stiamo raccogliendo testimonianze oculari!",
    "email": "Se sei di Cherson, Nikopol, Zaporizhzhia, Sumy o delle zone di prima linea del Donbas e hai assistito di persona a un “safari umano”, inviaci le tue storie a 📧 <mail>khersonhumansafari@gmail.com</mail>, oggetto: “safari umano.”",
    "type": "Se hai assistito alla morte di un amico o vicino in un attacco di droni e vuoi condividere la tua testimonianza, indica “testimone oculare”; se sei stato personalmente attaccato, indica “sopravvissuto.”",
    "requirements": "<b>Ciò di cui abbiamo bisogno:</b> città/luogo, data dell’attacco, breve racconto (3–6 frasi; factual, prima persona).",
    "honesty": "Sii onesto, conciso e evita di includere posizioni militari sensibili — puoi rimanere anonimo.",
    "media": "<b>Foto/video?</b> Scrivi “Foto/video disponibili”. Non allegare file — ti contatteremo se servono materiali visivi.",
    "consent": "<b>Consenso alla pubblicazione:</b> “Acconsento che questa storia venga pubblicata pubblicamente sul sito HumanSafari.org.”"
  },
  "resources": {
    "title": "Risorse chiave",
    "linkLibraryTitle": "Archivio link",
    "linkLibraryDesc": "200 articoli, rapporti, interviste, testimonianze dirette e copertura mediatica",
    "humanSafariMapTitle": "Mappa dell’Human Safari di Tochnyi",
    "humanSafariMapDesc": "Una mappa interattiva degli attacchi dell'Human Safari a Cherson, costruita a partire da segnalazioni open source delle autorità locali e da video degli attacchi geolocalizzati dal team di Tochnyi.",
    "truthHoundsTitle": "Rapporto Truth Hounds",
    "truthHoundsDesc": "Killzone: Come i droni russi devastano la sponda destra del fiume Dnipro",
    "hrwTitle": "Rapporto Human Rights Watch sugli attacchi con droni a Cherson",
    "hrwDesc": "Rapporto HRW",
    "unReportsTitle": "Rapporti del Consiglio ONU per i Diritti Umani",
    "report1": "Rapporto ONU #1",
    "report3": "Rapporto ONU #3",
    "guidelines": "Linee guida ONU",
    "wikipediaTitle": "Wikipedia",
    "english": "Inglese",
    "french": "Francese",
    "documentaryTitle": "Documentario",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "13-14 dicembre",
    "eyewitnesses": "testimonianze",
    "rallies": "le foto",
    "help": "Cherson deoccupata",
    "leftBank": "Cherson occupata",
    "action": "dicembre '25",
    "oleshky": "azione globale - Oleshky",
    "menu": "Menu"
  },
  "leftBank": {
    "pageTitle": "Assedio con droni",
    "para1": "Una grave emergenza umanitaria colpisce 6.000 civili intrappolati sotto un assedio di droni nelle località occupate di Oleshky, Hola Prystan, Stara Zburivka e Nova Zburivka - regione occupata di Cherson. A Oleshky 1.200 - 2.000. L'autorità occupante è obbligata a sostenerli - invece le forze russe li usano come scudi umani, per nascondersi dietro questa popolazione mentre conducono attacchi di safari umano sulla sponda opposta. Le autorità ucraine e le organizzazioni umanitarie denunciano un'ostruzione sistematica dell'evacuazione e dell'accesso umanitario.",
    "para2": "I civili sono privi di cibo, acqua, cure mediche, medicinali, elettricità, gas e comunicazioni. Le strade sono pesantemente minate e l'attività dei droni limita gli spostamenti. Dal 26 maggio nessun veicolo è potuto entrare o uscire. Le scorte di carburante e cibo sono quasi esaurite.",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "Video: «Kherson and Oleshky: Witnessing Genocide» (12 min)",
    "meidasArticle": "Articolo: «The Kherson Region: How Russia Uses Civilians as a Tool of War» (5 min di lettura)",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "Articolo: «Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate» (7 min di lettura)",
    "tellPost": "e parla dell'Assedio con droni agli altri",
    "callToHelp": "TU puoi aiutare. Ecco come",
    "donateIntro": "Queste iniziative offrono un aiuto mirato e ad alto impatto direttamente alle persone fuggite da Oleshky o, dove possibile, ancora intrappolate lì.",
    "signTitle": "Firma",
    "signSub": "petizioni",
    "petitionBy": "di {{name}}",
    "petitions": {
      "euParliament": "Parlamento europeo – Petizione n. 1439/2026 per l’istituzione di un corridoio umanitario di evacuazione per i civili intrappolati sotto assedio a Oleshky (Ucraina), occupata dalla Russia",
      "ukParliament": "Parlamento britannico – Istituire un corridoio di aiuti umanitari guidato dal Regno Unito verso Oleshky, in Ucraina"
    },
    "publicActionLead": "Punta i riflettori sull'assedio con droni dove ti trovi.",
    "organiseAction": "Organizza un'azione.",
    "policyBody": "Le autorità ucraine sono in consultazione con il Comitato Internazionale della Croce Rossa per l'istituzione di un corridoio umanitario di evacuazione dalle località occupate della regione di Kherson e per garantire l'accesso umanitario a cibo, acqua, medicine, carburante e assistenza medica. All'inizio di giugno non è in funzione alcun corridoio di evacuazione né un meccanismo stabile di accesso umanitario.",
    "documentaryTitle": "Oleshky, breve documentario",
    "downloadTitle": "Scarica",
    "downloadSub": "grafiche"
  },
  "footer": {
    "addCityText": "Per aggiungere la tua città, invia un'email a: ",
    "organiseText": "Aggiungi la tua manifestazione - contattaci:",
    "contact": "Contatto:"
  },
  "byCountry": "vedi per paese",
  "byDate": "vedi per data",
  "countries": {
    "australia": "Australia",
    "austria": "Austria",
    "bulgaria": "Bulgaria",
    "canada": "Canada",
    "czechia": "Repubblica Ceca",
    "denmark": "Danimarca",
    "estonia": "Estonia",
    "finland": "Finlandia",
    "france": "Francia",
    "georgia": "Georgia",
    "germany": "Germania",
    "hungary": "Ungheria",
    "italy": "Italia",
    "japan": "Giappone",
    "mexico": "Messico",
    "netherlands": "Paesi Bassi",
    "norway": "Norvegia",
    "poland": "Polonia",
    "romania": "Romania",
    "spain": "Spagna",
    "sweden": "Svezia",
    "southAfrica": "Sudafrica",
    "ukraine": "Ucraina",
    "unitedKingdom": "Regno Unito",
    "usa": "USA",
    "ireland": "Irlanda",
    "belgium": "Belgio"
  },
  "cities": {
    "alicante": {
      "city": "Alicante",
      "country": "Spagna",
      "time": "Alicante - Spagna, 16:00 - 17:00",
      "location": "Auditorio la Concha, Explanada de España",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "Barcellona",
      "country": "Spagna",
      "time": "Barcellona - Spagna, 12:00 - 14:00",
      "location": "Placa de Sant Jaume",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "Berkeley",
      "country": "USA",
      "time": "Berkeley - USA, 12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "Berlino",
      "country": "Germania",
      "time": "Berlino - Germania, 12:00",
      "location": "Tempelhofer Feld, ingresso Leinstr./angolo di Oderstr.",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "Bettendorf",
      "country": "USA",
      "time": "Bettendorf - USA, 17:30 - Proiezione",
      "location": "Bettendorf Public Library",
      "cleanTime": "17:30 - Proiezione",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "Birmingham",
      "country": "Regno Unito",
      "time": "Birmingham - Regno Unito, 14:00 - 15:30",
      "location": "Baskerville House, Cambridge St.",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "Bonn",
      "country": "Germania",
      "time": "Bonn - Germania, 14:00 - 16:00",
      "location": "Poststraße, davanti alla stazione principale",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "Bremen",
      "country": "Germania",
      "time": "Bremen - Germania, 15:00 - 18:00",
      "location": "Bahnhofsvorplatz",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "Budapest",
      "country": "Ungheria",
      "time": "Budapest - Ungheria, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "Chicago",
      "country": "USA",
      "time": "Chicago - USA, 13:00 - 15:00",
      "location": "410 N. Michigan ave. (Wrigley Building)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "Constanța",
      "country": "Romania",
      "time": "Constanța - Romania, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "Copenaghen",
      "country": "Danimarca",
      "time": "Copenaghen - Danimarca, 14:00",
      "location": "Axeltorv",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "Dallas",
      "country": "USA",
      "time": "Dallas - USA, 12:00 - 13:00",
      "location": "Dallas City Hall Plaza",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "Denver",
      "country": "USA",
      "time": "Denver - USA, 12:00",
      "location": "Colorado Capitol Building, gradini Ovest",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "Edimburgo",
      "country": "Regno Unito",
      "time": "Edimburgo - Regno Unito, 13:00 - 15:00",
      "location": "Duke of Wellington Monument",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "Fort Worth",
      "country": "USA",
      "time": "Fort Worth - USA, 14:00 - 15:00",
      "location": "Tarrant County Courthouse",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "Amburgo",
      "country": "Germania",
      "time": "Amburgo - Germania, 14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "Houghton, Michigan",
      "country": "USA",
      "time": "Houghton, Michigan - USA, 15:00",
      "location": "Portage Lake Lift Bridge",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "Helsinki",
      "country": "Finlandia",
      "time": "Helsinki - Finlandia, 17:00 - 18:00",
      "location": "Narinkkatori",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "Izumo",
      "country": "Giappone",
      "time": "Izumo - Giappone, 13:00",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "Izumo",
      "country": "Giappone",
      "time": "Izumo - Giappone",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "Kamloops",
      "country": "Canada",
      "time": "Kamloops - Canada, 15:00 - 16:00",
      "location": "Municipio",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "Kyiv",
      "country": "Ucraina",
      "time": "Kyiv - Ucraina, 17:00 - 18:00",
      "location": "Maidan Nezalezhnosti",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "Leipzig",
      "country": "Germania",
      "time": "Leipzig - Germania, 12:00 - 13:00",
      "location": "Willy Brandt Platz",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "Londra",
      "country": "Regno Unito",
      "time": "Londra - Regno Unito, 18:30 - Proiezione",
      "location": "Ukrainian House, 154 Holland Park Avenue",
      "cleanTime": "18:30 - Proiezione",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "Los Angeles",
      "country": "USA",
      "time": "Los Angeles - USA, 15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "Málaga",
      "country": "Spagna",
      "time": "Málaga - Spagna, 18:00 - Proiezione",
      "location": "Maydan - Centro Storico Culturale Ucraino",
      "cleanTime": "18:00 - Proiezione",
      "day": "schedule13"
    },
    "manchester": {
      "city": "Manchester",
      "country": "Regno Unito",
      "time": "Manchester - Regno Unito, 14:00 - 15:30",
      "location": "St Peter's Square Emmeline Pankhurst Memorial",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "Città del Messico",
      "country": "Messico",
      "time": "Città del Messico - Messico, 11:00",
      "location": "Alameda Central. Fontana \"Americhe\" (tra Hemiciclo Juárez e Chiosco)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "Milano",
      "country": "Italia",
      "time": "Milano - Italia, 15:00",
      "location": "Duomo di Milano",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "Monaco di Baviera",
      "country": "Germania",
      "time": "Monaco di Baviera - Germania, 17:00 - 19:00",
      "location": "Odeonsplatz",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "New York",
      "country": "USA",
      "time": "New York - USA, 16:00",
      "location": "Times Square",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "New York",
      "country": "USA",
      "time": "New York - USA, 13:00 - 14:00",
      "location": "Times Square",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule14"
    },
    "nienburg": {
      "city": "Nienburg (Weser)",
      "country": "Germania",
      "time": "Nienburg (Weser) - Germania, 17:00",
      "location": "Stettiner Str.2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "Oslo",
      "country": "Norvegia",
      "time": "Oslo - Norvegia, 12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "Östersund",
      "country": "Svezia",
      "time": "Östersund - Svezia, 11:00 - 14:00",
      "location": "Stortorget (Piazza principale)",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "Ottawa",
      "country": "Canada",
      "time": "Ottawa - Canada, 12:30 - 13:30",
      "location": "Ambasciata russa",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "Ottawa",
      "country": "Canada",
      "time": "Ottawa - Canada, 12:00",
      "location": "Ambasciata USA",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "Parigi",
      "country": "Francia",
      "time": "Parigi - Francia, 15:30",
      "location": "Square Taras Chevchenko -> Fontaine Saint-Michel (marcia)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "Plovdiv",
      "country": "Bulgaria",
      "time": "Plovdiv - Bulgaria, 16:00 - 17:00",
      "location": "vicino alla Casa Levski",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "Praga",
      "country": "Cechia",
      "time": "Praga - Cechia, 14:00",
      "location": "Palackého Square",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "Rosendal",
      "country": "Sudafrica",
      "time": "Rosendal - Sudafrica, 11:00",
      "location": "Uffici del South African Police Service",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "San Andrés, Tenerife",
      "country": "Spagna",
      "time": "San Andrés, Tenerife - Spagna, 13:00",
      "location": "--",
      "cleanTime": "13:00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "San Diego",
      "country": "USA",
      "time": "San Diego - USA, 14:00 - 16:00",
      "location": "El Cid Statue, Balboa Park",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "San Francisco",
      "country": "USA",
      "time": "San Francisco - USA, 14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "Schwerin",
      "country": "Germania",
      "time": "Schwerin - Germania, 19:00 - Proiezione",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - Proiezione",
      "day": "schedule13"
    },
    "seattle": {
      "city": "Seattle",
      "country": "USA",
      "time": "Seattle - USA, 12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "Sveti Vlas",
      "country": "Bulgaria",
      "time": "Sveti Vlas - Bulgaria, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "Sydney",
      "country": "Australia",
      "time": "Sydney - Australia, 14:00",
      "location": "Sydney Town Hall",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "Tallin",
      "country": "Estonia",
      "time": "Tallin - Estonia, 15:00 - Proiezione e manifestazione",
      "location": "Sõprus Cinema, Vana-Posti tn.8",
      "cleanTime": "15:00 - Proiezione e manifestazione",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "Tarragona",
      "country": "Spagna",
      "time": "Tarragona - Spagna, 18:30",
      "location": "Balcó Mediterrani",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "L'Aia",
      "country": "Paesi Bassi",
      "time": "L'Aia - Paesi Bassi, 13:00 - 15:00",
      "location": "Davanti al Palazzo della Pace / CPI",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "Tbilisi",
      "country": "Georgia",
      "time": "Tbilisi - Georgia, 21:00",
      "location": "Tbilisi",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "Tranås",
      "country": "Svezia",
      "time": "Tranås - Svezia, 11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "Vienna",
      "country": "Austria",
      "time": "Vienna - Austria, 16:00 - 18:00",
      "location": "Stock im Eisen Platz (vicino a Stephansdom)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "Washington D.C.",
      "country": "USA",
      "time": "Washington D.C. - USA, 12:30 - 13:30",
      "location": "Casa Bianca",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "Wrocław",
      "country": "Polonia",
      "time": "Wrocław - Polonia, 13:00",
      "location": "Piazza della Libertà (direzione People's Forum of Music)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "Organizza! Per aggiungere la tua città, invia un'email a:",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "Condividi su {{platform}}",
    "website": "Sito web",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "Zarina Zabrisky, giornalista e regista, ha organizzato la manifestazione mondiale e ha diretto il documentario Kherson Human Safari."
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "Protezione dei civili per le strade di Kherson — proteggendo i civili dagli attacchi dei droni.",
      "foodDesc": "Aiuti alimentari.",
      "foodNote": "Quando doni, scrivi «Food for Cherson» come causale."
    },
    "ahs": {
      "name": "Progetto Anti Human Safari",
      "desc": "Rilevatori di droni e giubbotti protettivi per volontari e servizi di emergenza a Kherson."
    },
    "pageTitle": "Fermate il Human Safari",
    "sectionIntro": "Dall'estate del 2024, i militari russi usano piccoli droni per cacciare, uccidere e terrorizzare civili nelle strade di Kherson e altre città di prima linea in Ucraina.",
    "sectionIntro2": "È una campagna di omicidi sistematica e deliberata: gli operatori di droni russi pubblicano apertamente i video delle loro vittime su canali Telegram per vantarsene. Nel maggio 2025 l'ONU ha riconosciuto l'Human Safari come un crimine di guerra in corso.",
    "sectionIntro3": "Si sta facendo troppo poco. Il Human Safari deve finire.",
    "sectionIntroBold": "VOI potete aiutare. Ecco come",
    "step2Title": "Organizza",
    "step3Title": "Dillo agli altri",
    "step3Para": "Usa gli hashtag",
    "step3ParaPost": "e parla del Human Safari agli altri",
    "instagram": "Instagram",
    "step2Bullet1": "una proiezione cinematografica",
    "step2Bullet2": "un'azione pubblica",
    "step2Bullet3": "una copertura mediatica",
    "publicActionLead": "Punta i riflettori sul safari umano dove ti trovi.",
    "reachOutPre": "Puoi",
    "reachOut": "contattarci",
    "reachOutPost": "per idee e risorse",
    "newsCoverageLead": "tramite i tuoi contatti nei media. Parla loro del safari umano e del rischio per tutte le zone di conflitto attuali e future.",
    "putInTouchPre": "Puoi anche",
    "putInTouch": "metterci in contatto diretto",
    "inform": "Informati",
    "informSub": "te stesso e gli altri",
    "policyTitle": "Politica",
    "policyBody": "La proposta di legge LORA (Liability for Operators and Responsible Authorities Act) introdurrebbe sanzioni lungo l'intera catena di responsabilità: dagli operatori e comandanti russi dei droni FPV fino agli alti vertici militari, nonché nei confronti dei produttori e fornitori che rendono possibile la produzione e l'impiego di droni contro i civili.",
    "policyHelp": "Puoi aiutare a livello politico?",
    "getInTouch": "Mettiti in contatto",
    "disdict": {
      "title": "Disinformation Dictionary",
      "link": "Human Safari"
    },
    "donate": "Dona",
    "donateIntro": "Queste iniziative offrono un aiuto mirato e ad alto impatto per proteggere direttamente i civili di Kherson dallo Human Safari.",
    "shareTitle": "Diffondi la notizia",
    "filmScreening": "Organizza una proiezione del documentario Kherson Human Safari:",
    "howItStarted": "Come è iniziato",
    "kryla": {
      "name": "Kryla Foundation",
      "desc": "Sostienili nel pagare alloggio e beni di prima necessità per gli abitanti di Oleshky."
    }
  },
  "action": {
    "intro": "Abbiamo iniziato con una manifestazione mondiale. Ora puoi:",
    "helpLink": "aiuta qui"
  },
  "accounts": {
    "heading": "Account"
  },
  "media": {
    "close": "Chiudi",
    "view": "Guarda il contenuto",
    "previous": "Precedente",
    "next": "Successivo",
    "andrushenkoCredit": "Oleksandr Andrushenko, fotoreporter della testata Vgoru",
    "khersonPoliceCredit": "da @khersonpolice",
    "antypenkoCredit": "Ivan Antypenko, fotogiornalista di Cherson",
    "telegramChannelCredit": "pubblicato sul canale Telegram russo dell'Human Safari «da Mariupol ai Carpazi»",
    "fruitSellerDescription": "Un venditore di frutta inseguito da un drone a fibra ottica",
    "burntCarDescription": "Auto bruciata a Cherson",
    "bridgeAttackDescription": "Un adolescente ucciso da un drone FPV sotto un ponte a Cherson",
    "busAttackDescription": "Uno dei tanti attacchi con droni FPV contro i mezzi pubblici",
    "fpvDroneDescription": "Drone FPV a caccia durante l'«Human Safari»",
    "antiDroneNetsDescription": "Strada di Cherson coperta da reti contro i droni dell'«Human Safari»",
    "firefighterDescription": "Un vigile del fuoco spegne un'auto dopo un attacco dell'«Human Safari», dietro giace una vittima"
  },
  "follow": {
    "title": "Segui",
    "subHumanSafari": "fonti di qualità che raccontano da Cherson e sull'Human Safari",
    "subDroneSiege": "fonti di qualità che raccontano da Cherson e sull'assedio con droni",
    "localPress": "stampa locale in ucraino",
    "lang": {
      "english": "inglese",
      "german": "tedesco",
      "ukrainian": "ucraino"
    },
    "language": "Lingua: {{list}}",
    "languages": "Lingue: {{list}}",
    "langSeparator": ", ",
    "zabrisky": {
      "name": "Zarina Zabrisky",
      "desc": "Giornalista e regista statunitense con base a Cherson, collabora con Byline Times ed Euromaidan Press; ha diretto il documentario Kherson Human Safari."
    },
    "naber": {
      "name": "Ibrahim Naber",
      "desc": "Caporeporter del quotidiano tedesco Die Welt; racconta periodicamente l'Human Safari a Cherson."
    },
    "kelley": {
      "name": "Brendan Kelley",
      "desc": "Scrive Kherson Weekly, una cronaca costante degli attacchi con droni russi contro i civili a Cherson e nei villaggi circostanti."
    },
    "vgoru": {
      "name": "Vgoru",
      "desc": "Piattaforma d'informazione indipendente della regione di Cherson, racconta la vita sotto attacco e sotto occupazione."
    },
    "suspilne": {
      "name": "Suspilne Cherson",
      "desc": "La redazione di Cherson dell'emittente pubblica ucraina."
    },
    "most": {
      "name": "MOST",
      "desc": "Agenzia di stampa locale di Cherson, segue la città e la regione."
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "FERMARE L'ASSEDIO CON DRONI",
      "heroSave": "SALVARE OLESHKY",
      "worldwideRally": "Azione globale",
      "heroDate": "Ottobre",
      "infoText1": "Migliaia di civili sono intrappolati sotto l'assedio dei droni a Oleshky, Hola Prystan, Stara Zburivka e Nova Zburivka. Le forze russe li usano come scudi umani, nascondendosi dietro di loro per condurre attacchi di safari umano con droni sulla sponda opposta.",
      "infoText2": "La crisi è acuta: mancano cibo, acqua, cure mediche, medicinali, elettricità, gas e comunicazioni. Le strade sono pesantemente minate e i droni limitano ogni spostamento. <bold>TU puoi aiutare. Unisciti a migliaia di persone nel mondo per chiedere la fine dell'assedio con droni.</bold>",
      "imageAlt": "Un cane affamato tra ossa umane nella Oleshky in rovina, sotto un cielo rosso pieno di droni, con la scritta Stop Russian Drone Siege",
      "demandsTitle": "Chiediamo:",
      "demand1": "corridoi umanitari sicuri ed efficaci verso Oleshky e le altre comunità colpite.",
      "demand2": "aiuti umanitari immediati e assistenza alle vittime degli attacchi di safari umano.",
      "demand3": "sanzioni adeguate contro le persone e le catene di approvvigionamento responsabili di attacchi contro i civili.",
      "demand4": "misure per scoraggiare l'uso di piccoli droni per colpire e terrorizzare sistematicamente i civili a Cherson, in Ucraina e altrove.",
      "cities": {
        "edinburgh": {
          "city": "Edimburgo",
          "country": "Regno Unito",
          "time": "Edimburgo - Regno Unito, 14:00",
          "location": "Duke of Wellington Monument",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "Birmingham",
          "country": "Regno Unito",
          "time": "Birmingham - Regno Unito, 14:00 - 16:00",
          "location": "Di fronte alla Hall of Memory, B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "Vienna",
          "country": "Austria",
          "time": "Vienna - Austria, 15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wien",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "Monaco di Baviera",
          "country": "Germania",
          "time": "Monaco di Baviera - Germania, 15:00 - 17:00",
          "location": "Marienplatz, 80331 München",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "Londra",
          "country": "Regno Unito",
          "time": "Londra - Regno Unito, 16:00 - 18:00",
          "location": "Downing Street",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "Manchester",
          "country": "Regno Unito",
          "time": "Manchester - Regno Unito, 14:00 - 15:30",
          "location": "St Peter's Square",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "Sydney",
          "country": "Australia",
          "time": "Sydney - Australia, 14:00",
          "location": "Sydney Town Hall",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "Parigi",
          "country": "Francia",
          "time": "Parigi - Francia, 15:30 - 18:30",
          "location": "Dalla chiesa di San Volodymyr a Place Saint-Michel",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "Parigi",
          "country": "Francia",
          "time": "Parigi - Francia, 18:00",
          "location": "Metro Rambuteau",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "Lione",
          "country": "Francia",
          "time": "Lione - Francia, 14:00",
          "location": "Place de la Comédie",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "Dublino",
          "country": "Irlanda",
          "time": "Dublino - Irlanda, 13:00",
          "location": "The GPO (Ufficio postale generale)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "Bruxelles",
          "country": "Belgio",
          "time": "Bruxelles - Belgio, 10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 Bruxelles (rotonda Schuman)",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "Ottawa",
          "country": "Canada",
          "time": "Ottawa - Canada, 12:30 - 13:30",
          "location": "Ambasciata russa, 285 Charlotte St",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "Nantes",
          "country": "Francia",
          "time": "Nantes - Francia, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "Danzica",
          "country": "Polonia",
          "time": "Danzica - Polonia, 18:30 - 19:30",
          "location": "Długi Targ, accanto alla Fontana di Nettuno",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "Dresda",
          "country": "Germania",
          "time": "Dresda - Germania, 14:00",
          "location": "Neumarkt",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "Malaga",
          "country": "Spagna",
          "time": "Malaga - Spagna, 19:00",
          "location": "Plaza de la Marina",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "Londra",
          "country": "Regno Unito",
          "time": "Londra - Regno Unito, 18:00",
          "location": "Trafalgar Square",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "Plovdiv",
          "country": "Bulgaria",
          "time": "Plovdiv - Bulgaria, 17:00",
          "location": "Via principale (Glavnata), vicino alla scalinata Kamenitza / alla scritta \"Together\"",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "Budapest",
          "country": "Ungheria",
          "time": "Budapest - Ungheria, 17:00 - 20:00",
          "location": "Szent István tér (piazza Santo Stefano)",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "Londra",
          "country": "Regno Unito",
          "time": "Londra - Regno Unito, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "Londra",
          "country": "Regno Unito",
          "time": "Londra - Regno Unito, 12:00",
          "location": "Trafalgar Square",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "Amburgo",
          "country": "Germania",
          "time": "Amburgo - Germania, 14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, all'altezza del pontile 1, 20359 Amburgo",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "Kiel",
          "country": "Germania",
          "time": "Kiel - Germania, 15:00 - 16:00",
          "location": "Holstenstraße",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "Oslo",
          "country": "Norvegia",
          "time": "Oslo - Norvegia",
          "location": "Eidsvolls plass",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "Leipzig",
          "country": "Germania",
          "time": "Leipzig - Germania, 17:00 - 18:00",
          "location": "Stazione centrale (Willy-Brandt-Platz)",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "Londra",
          "country": "Regno Unito",
          "time": "Londra - Regno Unito, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "Londra",
          "country": "Regno Unito",
          "time": "Londra - Regno Unito, 13:00",
          "location": "Trafalgar Square",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "Dublino",
          "country": "Irlanda",
          "time": "Dublino - Irlanda, 13:00",
          "location": "The GPO (Ufficio postale generale)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "Dublino",
          "country": "Irlanda",
          "time": "Dublino - Irlanda, 14:00",
          "location": "The GPO (Ufficio postale generale)",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "Nantes",
          "country": "Francia",
          "time": "Nantes - Francia, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "Fermate l'assedio russo con i droni",
      "posterNoRoadOut": "Le vie d'accesso e d'uscita da Oleshky sono bloccate",
      "posterHumanitarianCatastrophe": "Oleshky. Una catastrofe umanitaria sotto occupazione",
      "seeGallery": "Vedi / scarica i poster"
    },
    "artBy": "Arte: {{name}}",
    "downloadPoster": "Scarica il poster",
    "reel": {
      "download": "Scarica il video (MP4)"
    },
    "addDemo": {
      "title": "aggiungi la tua manifestazione",
      "where": "dove: città/paese",
      "contact": "email/numero",
      "message": "messaggio: chi rappresenti, la tua manifestazione è confermata o in preparazione, link all'annuncio online, altri dettagli",
      "submit": "Invia",
      "sending": "Invio…",
      "thanks": "Grazie! Ti contatteremo.",
      "error": "Qualcosa è andato storto. Riprova.",
      "contactInvalid": "Inserisci un'email valida o un numero di telefono con prefisso internazionale (es. +39 312 345 6789).",
      "date": "data",
      "time": "ora di inizio (locale)",
      "whereInvalid": "Inserisci il nome di una città o di un paese, es. Roma o Kyiv, Ucraina.",
      "datePlaceholder": "data: gg/mm"
    }
  },
  "seo": {
    "oleshky": {
      "title": "Fermiamo l'assedio con droni — Salviamo Oleshky",
      "description": "Droni russi assediano migliaia di civili a Oleshky, Ucraina occupata, senza cibo, acqua e medicinali. Trova una manifestazione vicino a te e chiedi un passaggio sicuro."
    },
    "leftBank": {
      "title": "Assedio con droni di Oleshky e della regione occupata di Kherson",
      "description": "Migliaia di civili sono intrappolati sotto un assedio russo con droni a Oleshky, Hola Prystan e nei villaggi occupati vicini. Scopri cosa succede e come puoi aiutare."
    },
    "help": {
      "title": "Fermiamo lo Human Safari — Droni russi danno la caccia ai civili a Kherson",
      "description": "Droni russi danno la caccia ai civili a Kherson, in Ucraina. Scopri il crimine di guerra dello Human Safari e come aiutare a fermarlo."
    },
    "action": {
      "title": "Manifestazione mondiale di dicembre 2025 — Fermiamo lo Human Safari",
      "description": "Foto, manifesti e luoghi della manifestazione mondiale di dicembre 2025 contro gli attacchi russi con droni sui civili a Kherson, in Ucraina."
    },
    "rallies": {
      "title": "Foto delle manifestazioni — Fermiamo lo Human Safari",
      "description": "Foto di manifestazioni in tutto il mondo contro gli attacchi russi con droni sui civili a Kherson, in Ucraina."
    },
    "resources": {
      "title": "Risorse sullo Human Safari — Rapporti, articoli e testimonianze",
      "description": "Rapporti, articoli, interviste e testimonianze sugli attacchi russi con droni contro i civili a Kherson, in Ucraina."
    },
    "reel": {
      "title": "Salviamo Oleshky — Video delle manifestazioni",
      "description": "Video delle manifestazioni mondiali «Salviamo Oleshky», ottobre 2026."
    }
  }
}
